export default "__VITE_ASSET__999dd947__"